import React from "react";
import "./footer.scss";

//Imagens:
import ImgLogoHyaia from "../../assets/navbar/logo-hyaia.png";
import {
  FaWhatsappSquare,
  FaInstagramSquare,
  FaFacebook,
  FaFacebookSquare,
  FaLinkedin,
  FaTwitterSquare,
  FaTwitch,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="container-generalfooter">
      <div className="container-footer">
        <div className="social-networks">
          <div className="img-logo-hyaia">
            <img src={ImgLogoHyaia} alt="logo Hyaia" />
          </div>
          <div className="texts-social-footer">
            <p>support@hyaia.com</p>
            <p>sales@hyaia.com</p>
            <p>{t("footer.social_media.follow_us_text")}</p>
            <div className="social-media-footer">
              {/* <a href="https://www.youtube.com/channel/UCJZhGWFb4XhLV8LLGh0-xvw/featured" target="_blank" style={{color:"black"}}><FaYoutube /></a> */}
              <a
                href="https://api.whatsapp.com/send/?phone=5511910160635&text&app_absent=0"
                target="_blank"
                style={{ color: "black" }}
              >
                <FaWhatsappSquare />
              </a>
              <a
                href="https://www.instagram.com/hyaiabra/"
                target="_blank"
                style={{ color: "black" }}
              >
                <FaInstagramSquare />
              </a>
              <a
                href="https://www.facebook.com/oficial.hyaiabra"
                target="_blank"
                style={{ color: "black" }}
              >
                <FaFacebookSquare />
              </a>
              <a
                href="https://www.linkedin.com/in/hyaia-bra-0429aa205/"
                target="_blank"
                style={{ color: "black" }}
              >
                <FaLinkedin />
              </a>
              {/* <FaTwitterSquare />
              <FaTwitch /> */}
            </div>
            <br />
            <br />
          </div>
        </div>
        <div className="servicos-e-suporte">
          <h1>{t("footer.suport_and_services.title")}</h1>
          <a href="/partnerships">
            <p>{t("footer.suport_and_services.partners_text")}</p>
          </a>
          <a href="/connectors">
            <p>{t("footer.suport_and_services.data_connection_text")}</p>
          </a>
          <a href="/TermsOfUse">
            <p>{t("footer.privacy_and_terms.terms_of_use")}</p>
          </a>
          <a href="/PrivacyPolicy">
            <p>{t("footer.privacy_and_terms.privacy_policy")}</p>
          </a>
          <p>{t("footer.change_language")}</p>
          <a
            style={{ fontWeight: "bold", cursor: "pointer" }}
            onClick={() => changeLanguage("pt-BR")}
          >
            PT |{" "}
          </a>
          <a
            style={{ fontWeight: "bold", cursor: "pointer" }}
            onClick={() => changeLanguage("en-US")}
          >
            EN |{" "}
          </a>
          <a
            style={{ fontWeight: "bold", cursor: "pointer" }}
            onClick={() => changeLanguage("es")}
          >
            ES
          </a>
          {/* <p>Central de Confiabilidade</p> */}
          {/* <p>Self Service BRA</p>
        </div>
        <div className="recursos">
          {/* <h1>RECURSOS</h1> */}
          {/* <p>Benefícios do BRA</p> */}
          {/* <p>Conexão de Dados</p> */}
          {/* <p>Preços</p> */}
          {/* <p>Criando um Dashboard</p> */}
        </div>
      </div>
    </div>
  );
};
export default Footer;
